import React, { useEffect, useState } from 'react'
import { getNoSaleReasonCodes } from '../services'
import { NoSaleReasonCodeOption, SellerServiceSessionCustomerItem } from '../types'

interface SessionCustomerResultModalProps {
  customer: SellerServiceSessionCustomerItem | null
  isLoading: boolean
  onConfirm: (data: { outcome: 'sale_completed' | 'no_sale'; saleAmount?: number; reasonCode?: number; note?: string }) => void
  onCancel: () => void
}

const centsToNumber = (digits: string): number =>
  digits ? Number((Number(digits) / 100).toFixed(2)) : 0

export const SessionCustomerResultModal: React.FC<SessionCustomerResultModalProps> = ({
  customer,
  isLoading,
  onConfirm,
  onCancel,
}) => {
  const [outcome, setOutcome] = useState<'sale_completed' | 'no_sale' | null>(null)
  const [saleAmount, setSaleAmount] = useState('')
  const [reasonCode, setReasonCode] = useState<number | undefined>()
  const [note, setNote] = useState('')
  const [reasons, setReasons] = useState<NoSaleReasonCodeOption[]>([])

  useEffect(() => {
    if (!customer) return
    setOutcome(null)
    setSaleAmount('')
    setReasonCode(undefined)
    setNote('')
    getNoSaleReasonCodes().then(setReasons).catch(() => setReasons([]))
  }, [customer])

  if (!customer) return null

  const canConfirm = outcome === 'sale_completed' || (outcome === 'no_sale' && !!reasonCode)

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,.5)' }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: 24, width: 420, maxWidth: 'calc(100vw - 32px)' }}>
        <h3 style={{ marginTop: 0 }}>Resultado do Cliente {customer.sequenceNumber}</h3>
        <p className='text-muted'>Este resultado será gravado somente para este cliente anônimo.</p>
        <div className='d-flex flex-column gap-2'>
          <label className='form-check'>
            <input className='form-check-input' type='radio' checked={outcome === 'sale_completed'} onChange={() => { setOutcome('sale_completed'); setReasonCode(undefined) }} />
            <span className='form-check-label'>Venda Concluída</span>
          </label>
          <label className='form-check'>
            <input className='form-check-input' type='radio' checked={outcome === 'no_sale'} onChange={() => { setOutcome('no_sale'); setSaleAmount('') }} />
            <span className='form-check-label'>Venda Não Concluída</span>
          </label>
        </div>
        {outcome === 'sale_completed' && (
          <input className='form-control mt-3' inputMode='numeric' placeholder='Valor da Venda (opcional)' value={saleAmount ? `R$ ${(Number(saleAmount) / 100).toFixed(2).replace('.', ',')}` : ''} onChange={(event) => setSaleAmount(event.target.value.replace(/\D/g, '').slice(0, 13))} />
        )}
        {outcome === 'no_sale' && (
          <>
            <select className='form-select mt-3' value={reasonCode || ''} onChange={(event) => setReasonCode(event.target.value ? Number(event.target.value) : undefined)}>
              <option value=''>Selecione o motivo da não venda</option>
              {reasons.map((reason) => <option key={reason.id} value={reason.id}>{reason.saleReasonCode}</option>)}
            </select>
            <textarea className='form-control mt-3' placeholder='Observação (opcional)' value={note} onChange={(event) => setNote(event.target.value)} />
          </>
        )}
        <div className='d-flex justify-content-end gap-2 mt-4'>
          <button className='btn btn-light' onClick={onCancel} disabled={isLoading}>Cancelar</button>
          <button className='btn btn-primary' onClick={() => outcome && onConfirm({ outcome, saleAmount: outcome === 'sale_completed' ? centsToNumber(saleAmount) : 0, reasonCode, note })} disabled={!canConfirm || isLoading}>{isLoading ? 'Salvando...' : 'Salvar resultado'}</button>
        </div>
      </div>
    </div>
  )
}
